import React, {Component, Fragment} from "react";
import "./EV.css";
import "./Election.css";
import Header from "./Header";
import Footer from "./Footer";
import Consulta from "./Consulta";
import axios from "axios";
import {Container, Row,Col} from "react-bootstrap";
import Dudas from "./Dudas";
import SaberMas from "./SaberMas";
import Video from "./Video";
import RunSerialMobileSearch from "./RunSerialMobileSearch";


class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            election: null,
            loading: false
        };
    }

    componentDidMount() {
        this.loadElection(this.props.match.params.election_id);
    }

    loadElection = election_id => {
        this.setState({loading: true}, () =>
            axios({
                method: "get",
                url: process.env.REACT_APP_API_URL + "/election/" + election_id

            })
                .then(response => {
                    this.setState({election: response.data, loading: false});
                }, error => {
                    this.setState({loading: false});
                })
        );
    };


    render() {


        return (
            <Container >

                {this.state.election != null ? (

                    <Fragment>
                        <Header election={this.state.election}/>

                        <Consulta election={this.state.election}  />



                        <Footer/>
                    </Fragment>

                ) : (
                    <Row>
                        <Col>
                            {this.state.loading ? (
                                <div className={"spinner"}/>
                            ) : (
                                <p>No fue posible cargar la elección</p>
                            )}
                        </Col>
                    </Row>
                )
                }
            </Container>);
    }
}


export default Home;
